import {Component, inject, OnInit} from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {AlgoliaWineProduct} from '@core/types/algolia-wine-product';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {Router} from '@angular/router';
import {ModalContainerComponent} from '@layout/components/modals/modal-container/modal-container.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProductCarouselComponent} from '@layout/components/product/product-carousel/product-carousel.component';
import {CartService} from '@core/services/cart.service';
import {Cart} from '@core/interfaces/generated/graphql';
import {formatPrice} from '@core/pipes/price.pipe';
import {faArrowLeft, faArrowRight} from '@fortawesome/free-solid-svg-icons';
import {StoreConfigService} from '@core/services/store-config.service';

@Component({
  selector: 'app-checkout-power-stop',
  templateUrl: './checkout-power-stop.component.html',
  styleUrls: ['./checkout-power-stop.component.scss'],
  imports: [FontAwesomeModule, ModalContainerComponent, ProductCarouselComponent, CurrencyPipe]
})
export class CheckoutPowerStopComponent implements OnInit {
  private router = inject(Router);
  private modalService = inject(NgbModal);
  private cartService = inject(CartService);
  private storeConfigService = inject(StoreConfigService);


  trendingProducts: AlgoliaWineProduct[];
  cartSignal = this.cartService.cartSignal;
  currencyCode = this.storeConfigService.currencyCode;

  showFreeDeliveryBar = false;

  ngOnInit() {
    this.showFreeDeliveryBar = formatPrice(this.cartService.currentCart().cart.totalPrice) < (this.storeConfigService.storeConfig()?.freeDeliveryStartsFrom || 0);
  }

  continue() {
    this.modalService.dismissAll();
    this.router.navigateByUrl('/checkout/cart');
  }

  close() {
    this.modalService.dismissAll();
  }

  untilFreeDelivery(cart: Cart) {
    const freeDelivery = this.storeConfigService.storeConfig()?.freeDeliveryStartsFrom || 0;
    if (!cart.totalPrice) {
      return freeDelivery;
    }
    return freeDelivery - formatPrice(cart.totalPrice);
  }

  progressWidth(untilFreeDelivery: number) {
    const progress = 100 - (untilFreeDelivery / 10);
    return progress + '%'
  }

  protected readonly faArrowLeft = faArrowLeft;
  protected readonly faArrowRight = faArrowRight;
}
